import styled from "styled-components";
import Scrollbars from "react-custom-scrollbars";

const Scrollbar = styled(Scrollbars)`
    margin-top:1rem;
    > div:nth-child(3):not(.bar){
        height: 60%;
        margin: auto 0;
        background-color: transparent;
    }
    > div:first-child{
        margin-right:-16px!important;
    }
    > div:nth-child(3) > div{
        background-color: ${({theme}) => theme.scroll}!important;
        opacity: .8;
    }
    
    > div:nth-child(2) {
        display: none;
    }`

export default Scrollbar